var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 5.00008H35C35.442 5.00008 35.8659 5.17568 36.1785 5.48824C36.4911 5.8008 36.6666 6.22472 36.6666 6.66675V33.3334C36.6666 33.7754 36.4911 34.1994 36.1785 34.5119C35.8659 34.8245 35.442 35.0001 35 35.0001H4.99998C4.55795 35.0001 4.13403 34.8245 3.82147 34.5119C3.50891 34.1994 3.33331 33.7754 3.33331 33.3334V6.66675C3.33331 6.22472 3.50891 5.8008 3.82147 5.48824C4.13403 5.17568 4.55795 5.00008 4.99998 5.00008H11.6666V1.66675H15V5.00008H25V1.66675H28.3333V5.00008ZM6.66665 15.0001V31.6667H33.3333V15.0001H6.66665ZM9.99998 21.6667H18.3333V28.3334H9.99998V21.6667Z",
    fill: "#115533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.36b0da01e445475c30ab2baf2c5709d8.svg";
export { ForwardRef as ReactComponent };